<div class="dorm" [ngClass]="{'expanded': showList}">
  <div class="dorm_left">
    <div class="dorm_thumb_web">
      <img ngOptimizedImage 
           class="main_image" 
           [ngSrc]="room?.roomImages?.[0]?.imageLink" 
           [width]="120" 
           [height]="120" 
           (error)="onImageError($event)"
           alt="">
    </div>
    <div class="dorm_thumb_mobile">
      <img ngOptimizedImage 
           class="main_image" 
           [ngSrc]="room?.roomImages?.[0]?.imageLink" 
           [width]="98" 
           [height]="98" 
           (error)="onImageError($event)"
           alt="">
    </div>
    <div class="dorm_details">
      <div class="dorm_name text medium truncate-1-line" style="font-size: 18px;">
        {{room.name}}
      </div>
      <div class="dorm_description text light truncate-2-lines" style="font-size: 18px;">
        <ng-container *ngIf="room.description">
          <p>
            {{room.description }}
          </p>
        </ng-container>
      </div>
      <div class="dorm_amenities dorm_amenities_web text xsmall">
        <div style="display: flex; align-items: center">
          <svg-icon style="margin-right: 3px; display: inline-flex" [svgStyle]="{'width.px': 16, 'height.px': 16}" src="/assets/icons/ensuite.svg"></svg-icon>
          Sleeps {{room.occupancy}}
        </div>
        <div style="display: flex; align-items: center" *ngIf="room.enSuite">
          <svg-icon style="margin-right: 3px; display: inline-flex" [svgStyle]="{'width.px': 16, 'height.px': 16}" src="/assets/icons/ensuite.svg"></svg-icon>
          Ensuite
        </div>
        <div style="display: flex; align-items: center" *ngIf="room.dormRoomGender === 1">
          <svg-icon style="margin-right: 3px; display: inline-flex" [svgStyle]="{'width.px': 16, 'height.px': 16}" src="/assets/icons/ensuite.svg"></svg-icon>
          Male only
        </div>
        <div style="display: flex; align-items: center" *ngIf="room.dormRoomGender === 2">
          <svg-icon style="margin-right: 3px; display: inline-flex" [svgStyle]="{'width.px': 16, 'height.px': 16}" src="/assets/icons/ensuite.svg"></svg-icon>
          Female only
        </div>
      </div>
    </div>
  </div>
  <div class="dorm_amenities dorm_amenities_mobile text xsmall">
    <div style="display: flex; align-items: center">
      <svg-icon style="margin-right: 3px; display: inline-flex" [svgStyle]="{'width.px': 16, 'height.px': 16}" src="/assets/icons/ensuite.svg"></svg-icon>
      Sleeps {{room.occupancy}}
    </div>
    <div style="display: flex; align-items: center" *ngIf="room.enSuite">
      <svg-icon style="margin-right: 3px; display: inline-flex" [svgStyle]="{'width.px': 16, 'height.px': 16}" src="/assets/icons/ensuite.svg"></svg-icon>
      Ensuite
    </div>
    <div style="display: flex; align-items: center" *ngIf="room.dormRoomGender === 1">
      <svg-icon style="margin-right: 3px; display: inline-flex" [svgStyle]="{'width.px': 16, 'height.px': 16}" src="/assets/icons/ensuite.svg"></svg-icon>
      Male only
    </div>
    <div style="display: flex; align-items: center" *ngIf="room.dormRoomGender === 2">
      <svg-icon style="margin-right: 3px; display: inline-flex" [svgStyle]="{'width.px': 16, 'height.px': 16}" src="/assets/icons/ensuite.svg"></svg-icon>
      Female only
    </div>
  </div>
  <div class="dorm_right">
    <div class="top">
      <div class="dorm_price" [ngClass]="{'hidden': showList}">
        <div class="text light" style="font-size: 15px">
          from
        </div>
        <div class="subheader">
          <ng-container *ngIf="(currency | async) as c">
            {{ (room.rates?.nonRefundable.price || room.rates?.standard.price) | currency : c.code }}
          </ng-container>
        </div>
        <div class="per text light flex" style="font-size: 15px">
          <div class="dot_after">
            {{ room.roomType === 1 ? 'per bed' : 'per room' }}
          </div>
          <div>
            per night
          </div>
        </div>
      </div>
      <div class="add_rooms">
        <button [@fadeIn] class="btn btn-raised theme" (click)="showList = !showList;">
          <svg-icon style="height: 18.2px" *ngIf="showList" [svgStyle]="{'width.px': 18.2, 'height.px': 18.2, stroke: 'white'}" src="/assets/icons/arrow_down.svg"></svg-icon>
          <svg-icon style="height: 16px" *ngIf="!showList" [svgStyle]="{'width.px': 18.2, 'height.px': 18.2, stroke: 'white'}" src="/assets/icons/plus_2_white.svg"></svg-icon>
          <ng-container i18n>Add Rooms</ng-container>
        </button>
      </div>
    </div>
    <div class="bottom" @listFadeSlide *ngIf="showList">
      <div class="room" @fadeIn *ngIf="room.standard">
        <div class="room_details">
          <div class="subheader">
            <ng-container *ngIf="(currency | async) as c">
              {{ room.standard | currency: c.code }}
            </ng-container>
          </div>
          <div class="text light">Non Refundable</div>
          <div class="text accent" style="display: flex; align-items: center;" *ngIf="roomHasFreeBreakfast(room);">
            <svg-icon style="height: 18.2px; margin-right: 3px;" [svgStyle]="{'width.px': 18.2, 'height.px': 18.2}" src="/assets/icons/breakfast.svg"></svg-icon>
            Breakfast Included
          </div>
        </div>
        <div class="room_counter">
          <div [@fadeIn] class="btn btn-frame-negative">
            <button class="room-count-changer" (click)="decrement('standard');">
              <svg-icon style="height: 18.2px" [svgStyle]="{'width.px': 18.2, 'height.px': 18.2}" src="/assets/icons/minus_2.svg"></svg-icon>
            </button>
            <span class="room-count">{{(selectedBeds | async)?.rates?.standard || 0}}</span>
            <button class="room-count-changer" (click)="increment('standard');" [disabled]="disableIncrement | async">
              <svg-icon class="black" style="height: 18.2px" [svgStyle]="{'width.px': 18.2, 'height.px': 18.2, 'stroke': 'black'}" src="/assets/icons/plus.svg"></svg-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="room_list">
        <div class="room" @fadeIn *ngIf="room.standardRate">
          <div class="room_details">
            <div class="subheader">
              <ng-container *ngIf="(currency | async) as c">
                {{ room.standardRate | currency: c.code }}
              </ng-container>
            </div>
            <div class="text light">Free cancellation</div>
          </div>
          <div class="room_counter" [ngClass]="{'disabled':  (disableStandard | async)}">
            <div [@fadeIn] class="btn btn-grey">
              <button class="room-count-changer" (click)="decrement('standard');">
                <svg-icon style="height: 18.2px" [svgStyle]="{'width.px': 18.2, 'height.px': 18.2}" src="/assets/icons/minus_2.svg"></svg-icon>
              </button>
              <span class="room-count">{{(selectedBeds | async)?.rates?.standard || 0}}</span>
              <button class="room-count-changer" (click)="increment('standard');" [disabled]="(disableIncrement | async) || (disableStandard | async)">
                <svg-icon class="black" style="height: 18.2px" [svgStyle]="{'width.px': 18.2, 'height.px': 18.2, 'stroke': 'black'}" src="/assets/icons/plus.svg"></svg-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="room" @fadeIn *ngIf="room.nonRefundableRate">
          <div class="room_details">
            <div class="subheader">
              <ng-container *ngIf="(currency | async) as c">
                {{ room.nonRefundableRate | currency: c.code }}
              </ng-container>
            </div>
            <div class="text light">Non Refundable</div>
          </div>
          <div class="room_counter" [ngClass]="{'disabled':  (disableNonRefundable | async)}">
            <div [@fadeIn] class="btn btn-grey">
              <button class="room-count-changer" (click)="decrement('nonRefundable');">
                <svg-icon style="height: 18.2px" [svgStyle]="{'width.px': 18.2, 'height.px': 18.2}" src="/assets/icons/minus_2.svg"></svg-icon>
              </button>
              <span class="room-count">{{(selectedBeds | async)?.rates?.nonRefundable || 0}}</span>
              <button class="room-count-changer" (click)=  "increment('nonRefundable');" [disabled]="(disableIncrement | async) || (disableNonRefundable | async)">
                <svg-icon class="black" style="height: 18.2px" [svgStyle]="{'width.px': 18.2, 'height.px': 18.2, 'stroke': 'black'}" src="/assets/icons/plus.svg"></svg-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
